import { useCallback, useContext, useEffect, useState } from 'react';
import { Destructor } from 'app/shared/utilities/Destructor';
import Snackbar from '@mui/material/Snackbar';
import { AgricultureToastProps } from 'app/agriculture/AgricultureToast/agriculture_toast_service';
import { ServicesContext } from 'app/items/shared/context_interface';
import { ToastContent } from 'app/agriculture/AgricultureToast/components/ToastContent/ToastContent';

export const AgricultureToast = () => {
    const { agricultureToastService } = useContext(ServicesContext);
    const [toast, setToast] = useState<AgricultureToastProps>();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    useEffect(() => {
        const destructor = new Destructor(
            agricultureToastService.onMessage((newToast: AgricultureToastProps | null) => {
                if (newToast) {
                    setToast(newToast);
                    setIsOpen(true);
                } else {
                    setIsOpen(false);
                }
            }),
        );
        return destructor.destroy;
    }, [agricultureToastService]);

    const handleClose = useCallback(
        (event: React.SyntheticEvent<unknown> | Event, reason: string) => {
            if (toast?.showOnClickAway && reason === 'clickaway') {
                return;
            }
            close();
        },
        [toast],
    );

    const close = () => {
        setIsOpen(false);
    };

    return (
        <Snackbar
            className="toast-snackbar"
            open={isOpen}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={6000}
        >
            <div className="toast-snackbar-content">
                {!toast ? null : <ToastContent {...toast} onClose={close} />}
            </div>
        </Snackbar>
    );
};
